module.exports = __webpack_public_path__ + "img/prospect4.b50c4392.jpg";